// To update the version number, please do so in package.json.
// Do not manually update this file.
// This file is generated/updated by the build process.
// The build process keeps this value in sync with package.json.
export const version = '2.002';
